const css = `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

/* Fix visible slider checkbox */
input {
  transform: scale(0.5);
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider::before {
  position: absolute;
  content: "";
  height: 26px;
  width: 28px;
  left: 0;
  bottom: 0;
  background-color: #ffffff;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #2196f3;
}

input:focus + .slider {
  box-shadow: #2196f3;
}

input:checked + .slider::before,
input:checked + .slider > .emoji {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
  display: flex;
  align-items: center;
}

.slider.round::before {
  border-radius: 50%;
  display: grid;
  place-items: center;
}

.slider::after {
  display: inline;
  position: absolute;
  right: 9.3%;
  bottom: 17.5%;
}

input:checked + .slider::after {
  display: inline;
  position: absolute;
  right: 56.3%;
  bottom: 14.5%;
}

.emoji {
  z-index: 10;
  display: flex;
  align-items: center;
  margin-left: 2px;
}

@media all and (max-width: 786px) and (min-width: 425px) {
  input:checked + .slider::after {
    right: 60.3%;
    bottom: 20.5%;
  }
  .slider::after {
    right: 15.3%;
    bottom: 22.5%;
  }
}
@media all and (max-width: 2560px) and (min-width: 1552px) {
  .slider::after {
    bottom: 12.5% !important;
  }
}
@media all and (max-width: 1552px) and (min-width: 1440px) {
  .slider::after {
    bottom: 7.5% !important;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
